__turbopack_context__.v({
  "className": "noto_sans_sc_8fb3a6e-module__kaieuq__className",
  "variable": "noto_sans_sc_8fb3a6e-module__kaieuq__variable",
});
